import type { Point } from "./asset-drop.js";

export interface GenerationPickerPosition {
  left: number;
  top: number;
}

const viewportInset = 12;
const pickerWidth = 300;
const pickerHeight = 210;

function clamp(value: number, minimum: number, maximum: number): number {
  return Math.min(Math.max(value, minimum), Math.max(minimum, maximum));
}

export function generationPickerPosition(input: {
  client: Point;
  viewport: { width: number; height: number };
}): GenerationPickerPosition {
  return {
    left: clamp(
      input.client.x,
      viewportInset,
      input.viewport.width - pickerWidth - viewportInset
    ),
    top: clamp(
      input.client.y,
      viewportInset,
      input.viewport.height - pickerHeight - viewportInset
    )
  };
}
